import React from "react";
import { useInView } from "../hooks/useInView";
import { trackEvent } from "../utils/analytics";

const Contact = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const handlePhoneClick = () => {
    trackEvent("telefon_kontakt", {
      category: "Kontakt",
      label: "Numer telefonu",
      phone_number: "+48602476604",
    });
  };

  const handleEmailClick = () => {
    trackEvent("email_kontakt", {
      category: "Kontakt",
      label: "Adres email",
      email: "biuro@lumat.com.pl",
    });
  };

  return (
    <section
      id="contact"
      className="section-padding bg-secondary-900 text-white"
    >
      <div className="container-custom">
        <div ref={ref} className="mb-16">
          <h2
            className={`text-4xl md:text-6xl lg:text-7xl xl:text-8xl font-light font-heading mb-8 transition-all duration-700 ${
              inView ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
            }`}
          >
            Kontakt
          </h2>
          <p
            className={`text-[18px] text-textSpecial1-500 max-w-3xl transition-all duration-700 delay-200 pt-4 ${
              inView ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
            }`}
          >
            Masz pytanie lub szukasz konkretnej części? Skontaktuj się z nami –
            chętnie pomożemy!
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-1 gap-12 lg:gap-16">
          {/* Contact Person */}
          <div
            className={`transition-all duration-700 delay-300 ${
              inView ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-8"
            }`}
          >
            <div className="flex flex-col lg:flex-row py-8 gap-8 lg:gap-20">
              <div className="flex-1">
                <p className="text-2xl font-regular font-heading md:text-3xl lg:text-4xl xl:text-5xl leading-tight mb-2">
                  Lumat Łukasz Wojtczuk
                </p>
                <p className="text-2xl font-regular font-heading md:text-3xl lg:text-4xl xl:text-5xl leading-tight mb-2">
                  tel.{" "}
                  <a
                    href="tel:+48602476604"
                    className="text-textSpecial2-500"
                    alt="Zadzwoń do Łukasza Wojtczuka +48 602 476 604"
                    onClick={handlePhoneClick}
                  >
                    602 476 604
                  </a>
                </p>
                <p className="text-2xl font-regular font-heading md:text-3xl lg:text-4xl xl:text-5xl leading-tight">
                  e-mail{" "}
                  <a
                    href="mailto:biuro@lumat.com.pl"
                    className="text-textSpecial2-500"
                    onClick={handleEmailClick}
                  >
                    biuro@lumat.com.pl
                  </a>
                </p>
              </div>
              <div className="hidden lg:block bg-textSpecial1-500 w-[1px] h-20 my-auto" />
              <div className="flex-1">
                <p className="text-2xl font-regular font-heading md:text-3xl lg:text-4xl xl:text-5xl leading-tight mb-2">
                  ul. Św. Proroka Eliasza 4
                </p>
                <p className="text-2xl font-regular font-heading md:text-3xl lg:text-4xl xl:text-5xl leading-tight mb-2">
                  15-568
                </p>
                <p className="text-2xl font-regular font-heading md:text-3xl lg:text-4xl xl:text-5xl leading-tight">
                  Białystok
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div
          className={`mt-8 pt-8 border-t border-secondary-700 transition-all duration-700 delay-700 ${
            inView ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
          }`}
        >
          <p className="text-white text-[18px] font-regular">
            © 2025 Lumat. All rights reserved.
            <span className="mx-2">|</span>
            <a
              href="/polityka-prywatnosci"
              className="text-textSpecial2-500 hover:text-primary-500 transition-colors"
            >
              Polityka prywatności
            </a>
          </p>
        </div>
      </div>
    </section>
  );
};

export default Contact;
